// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Wf_q","requiredAsterisk":"Info_requiredAsterisk__2n83R"};